import {uuid} from 'vue-uuid'

export const state = () => ({
  list: [],
  new: []
});

//commit mutations
export const mutations = {
  GET_LIST(state) {
    return state.list
  },
  SET_LIST(state, items) {
    state.list = items
  },
  SET_NEW(state, items) {
    state.new = items
  },
  ADD_NEW(state, item) {
    item.uuid = uuid.v4()
    state.new.push(item)
  },
  EDIT_NEW(state, item) {
    const idx = state.new.indexOf(element => element.uuid === item.uuid)
    state.new.splice(idx, 1, item)
  },
  REMOVE_NEW(state, item) {
    const idx = state.new.indexOf(element => element.uuid === item.uuid)
    state.new.splice(idx, 1)
  }
};
//dispatch actions
export const actions = {

  async listCliente({rootState, commit}, cliente) {
    rootState.loading = true
    const res = await this.$axios.get(`clientes/${cliente}/tecnicos`)
    rootState.loading = false
    if (res) {
      commit('SET_LIST', res.data)
      return res.data
    }
  },

  async listEmpresa({rootState, commit}, empresa) {
    rootState.loading = true
    const res = await this.$axios.get(`empresas/${empresa}/tecnicos`)
    rootState.loading = false
    if (res) {
      commit('SET_LIST', res.data)
      return res.data
    }
  },

  async create({rootState, state}, payload) {
    
    const tecnico = payload.tecnico
    const cliente_uuid = payload.cliente_uuid
    rootState.loading = true
    if (state.new.length > 0) {
      debugger
      for (let i=0; i < state.new.length; i++) {
        const item = state.new[i]
        let body = {
          ...item,
          cliente: cliente_uuid,
          username: item.user.username,
          email: item.user.email,
        }
        const xhr = await this.$axios.post(`usuarios`, body)
        if (xhr) return xhr
      }
    }
    else if (tecnico) {
      let body = {
        ...tecnico,
        //cliente: cliente_uuid,
        uuid: uuid.v4()
      }
      body.plainPassword = body.password
      body.tipo = 'tecnico'
      body.city = '/api/localidades/'+body.localidad
      body.direccion = body.direccion
      body.cp = body.cp
      body.persistDirecciones = [
        {
          principal: true,
          direccion: body.direccion,
          codigoPostal: body.cp,
          localidad: body.city,
          tipo: 'Fiscal'
        }
      ]
      const xhr = await this.$axios.post(`usuarios`, body)
      if (xhr) return xhr.data
    }
    rootState.loading = false
  },

  async update({rootState, state}, params) {
    
    const body = {
      ...params.tecnico,
      username: params.tecnico.user.username,
      //cliente: params.cliente_uuid,
      //tecnico: params.tecnico.uuid
    }
    //debugger
    delete(body.contactos)
    delete(body.cliente.contactos)
    delete(body.empresa)
    body.cliente = body.cliente['@id']
    rootState.loading = true
    await this.$axios.patch(`usuarios/${params.tecnico.uuid}`, body,{
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
    rootState.loading = false
  },

  async delete({rootState}, params) {
    rootState.loading = true
    await this.$axios.delete(`clientes/${params.cliente_uuid}/tecnicos/${params.uuid}`)
    rootState.loading = false
  },

  async changePassword({rootState}, params) {
    rootState.loading = true
    const body = {
      tecnico: params.tecnico.uuid,
      password: params.tecnico.password
    }
    await this.$axios.patch(`clientes/${params.cliente_uuid}/tecnicos/${params.tecnico.uuid}/change-password`, body)
    rootState.loading = false
  },

};
